/**
 * cpMinimalizeSidebar - Directive for minimalize sidebar
 */

(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpMinimalizeSidebar', cpMinimalizeSidebar);

    cpMinimalizeSidebar.$inject = ['$timeout'];

    function cpMinimalizeSidebar($timeout) {
        return {
            restrict: 'A',
            templateUrl: 'app/caffeprint/directives/minimalize-sidebar/minimalize-sidebar.html',
            link: function(scope, element) {
                scope.minimalize = minimalize;

                function minimalize() {
                    angular.element('body').toggleClass('mini-navbar');

                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {

                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();

                        // For smoothly turn on menu
                        $timeout(function() {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else if (angular.element('body').hasClass('fixed-sidebar')) {
                        angular.element('#side-menu').hide();

                        $timeout(function() {
                            angular.element('#side-menu').fadeIn(400);
                        }, 100);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                }
            }
        };
    }
})();
